module.exports= {server_url: "https://app.fmeasure.com",
				 stripe_key: "pk_live_S2tRaWXpHzDl4QRYZGfgndgM"};



// WEBPACK FOOTER //
// ./src/global.js